import { styled } from '@material-ui/core/styles';
import MuiTab from '@material-ui/core/Tab';

export const Tab = styled(MuiTab)({
  '& .MuiTab-wrapper': {
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'lowercase'
  }
});